<template>
  <div class="uk-container">
    <div v-if="list.length" class="uk-width-large uk-margin-auto uk-card uk-card-default">
      <vue-good-table
        :columns="columns"
        :rows="list"
        :pagination-options="$globals.vgt.pagination"
        style-class="uk-table uk-table-middle uk-table-divider uk-table-hover uk-margin-remove datatable"
        @on-row-click="onRowClick"
      />
    </div>

    <div v-else class="uk-card uk-card-default uk-padding uk-text-center uk-width-large uk-margin-auto">
      There are no tickets at the moment!
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewTicketList',

  data() {
    return {
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Date Created',
          field: 'created'
        },
        {
          label: 'Status',
          field: 'status',
          html: true
        }
      ]
    }
  },

  computed: {
    list() {
      const source = this.$store.state.tickets.collection
      const rows = []

      source.forEach((item) => {
        rows.push({
          id: item.id,
          name: item.content.name,
          created: this.$moment(item.info.created.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss'),
          status: this.formatStatus(item.info.status)
        })
      })

      return rows
    }
  },

  methods: {
    onRowClick(params) {
      this.$router.push({ name: 'ticket-single', params: { id: params.row.id } })
    },

    formatStatus(data) {
      let label = '<div class="uk-label uk-label-danger">N/A</div>'
      const option = this.$helpers.status.ticket.find((o) => o.id === data)
      label = `<div class="uk-label uk-label-${option.class}">${option.value}</div>`
      return label
    }
  }
}
</script>
